import React from 'react'

import CatalogState from 'components/CatalogState'
import SupportVideoDetailsSkeleton from 'components/SupportVideoDetailsSkeleton'
import WistiaPlayer from 'components/WistiaPlayer'
import Wrapper from 'components/Wrapper'
import useI18n from 'hooks/useI18n'
import { FormSpacer } from 'ui/styled'

import useController from './controller'
import { Description, DescriptionPanel, DescriptionTitle, Viewer } from './styled'

export default function SupportVideoDetails() {
  const { t } = useI18n()
  const { categoryId, error, loading, retry, video } = useController()

  return (
    <>
      <FormSpacer extraLarge />
      {loading ? (
        <SupportVideoDetailsSkeleton />
      ) : (
        <Wrapper
          data={{
            section: t('service-supports'),
            breadcrumbs: [
              { label: t('home'), icon: 'home', to: '/dashboard' },
              { label: t('service-supports'), to: '/sub-category/service-supports', primary: true },
              { label: t('support_videos'), to: error ? null : `/sub-category/${categoryId}/service-supports` },
              !video?.title ? null : { label: video.title, to: null },
            ].filter(Boolean),
          }}
          wide
          nobutton
          noShare
        >
          {error ? (
            <CatalogState
              actionLabel={t('try_again')}
              description={t('support_videos_error')}
              onAction={retry}
              title={t('support_video_unavailable')}
            />
          ) : !video?.video_id && !video?.video?.url ? (
            <CatalogState
              description={t('support_video_media_missing_description')}
              title={t('support_video_media_missing')}
            />
          ) : (
            <Viewer>
              <WistiaPlayer course={video} minHeight="420px" showDetails={false} />
              {!video?.description ? null : (
                <DescriptionPanel>
                  <DescriptionTitle>{t('support_video_about')}</DescriptionTitle>
                  <Description>{video.description}</Description>
                </DescriptionPanel>
              )}
            </Viewer>
          )}
        </Wrapper>
      )}
    </>
  )
}
